/**
 * AdminPageShell — chrome único de todas las pages del dashboard.
 *
 * Una sola app: React + Vite + React Router bajo `/admin` + AdminLayout.
 * No hay shell Nuxt/Next; no hay segunda app en `/dashboard`.
 */

import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type AdminPageShellProps = {
  children: ReactNode;
  className?: string;
  /** max-w-3xl | 5xl | 6xl | 7xl — default 5xl */
  width?: "sm" | "md" | "lg" | "xl" | "full";
};

const WIDTH: Record<NonNullable<AdminPageShellProps["width"]>, string> = {
  sm: "max-w-3xl",
  md: "max-w-5xl",
  lg: "max-w-6xl",
  xl: "max-w-7xl",
  full: "max-w-none",
};

export function AdminPageShell({
  children,
  className,
  width = "md",
}: AdminPageShellProps) {
  return (
    <div
      className={cn(
        "admin-page mx-auto w-full min-w-0 space-y-6 pb-16 text-white/90",
        "[&_[data-admin-surface]]:transition-colors",
        WIDTH[width],
        className,
      )}
      data-admin-shell="vite-spa"
    >
      {children}
    </div>
  );
}
